import React from 'react';
import Modal from './Modal';
import Button from './Button';
import styles from './ConfirmDialog.module.css';

// Shared confirm-before-destructive-action dialog — every delete action in the
// app should go through this rather than firing straight from a click handler.
class ConfirmDialog extends React.Component {
  render() {
    const {
      open,
      title = 'Are you sure?',
      message,
      confirmLabel = 'Delete',
      cancelLabel = 'Cancel',
      danger = true,
      loading = false,
      onConfirm,
      onCancel,
    } = this.props;

    return (
      <Modal open={open} onClose={onCancel} title={title} width="420px">
        <div className={styles.body}>
          {message}
        </div>
        <div className={styles.actions}>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </div>
      </Modal>
    );
  }
}

export default ConfirmDialog;
